import { MonitoringCounts, SubscriptionConfiguration } from '@/types';

/**
 * Static placeholder cost for subscription calculation.
 * TODO: Implement actual calculation logic based on subscription flags,
 * scan schedule, and monitoring counts.
 */
const PLACEHOLDER_SUBSCRIPTION_COST = 10000;

export function useCalculateSubscriptionCost(_props: {
  subscription: SubscriptionConfiguration;
  monitoringCounts: MonitoringCounts;
}): number {
  // Props are unused in placeholder implementation, but will be needed when implemented
  // Static value - no need for useMemo, React Compiler handles optimization
  // TODO: When implemented, this will use _props.subscription and _props.monitoringCounts
  return PLACEHOLDER_SUBSCRIPTION_COST;
}

export const formatPrice = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};
